import { render, staticRenderFns } from "./ProgramsSelectField.vue?vue&type=template&id=38348d83"
import script from "./ProgramsSelectField.vue?vue&type=script&lang=js"
export * from "./ProgramsSelectField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports